import styled, {css} from 'styled-components';

export const BlurredOverlay = styled.div<{
  $enableBlur?: boolean;
  $zIndex?: number;
}>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-tap-highlight-color: transparent;

  ${({$zIndex}) =>
    $zIndex &&
    css`
      z-index: ${$zIndex};
    `}

  background: rgba(0, 0, 0, 0.6);

  ${({$enableBlur}) =>
    $enableBlur &&
    css`
      backdrop-filter: blur(4px);
    `}
`;
